var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFjLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 22,
    viewBox: "0 0 28 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.334 4.31467C23.3168 4.31467 25.1675 2.95863 25.6 0C23.9333 1.18245 21.8429 1.48812 19.2262 1.48812C11.4596 1.48812 11.8338 4.79394 8.75025 7.75257C7.37528 9.07465 4.69256 9.25705 4 8.57903C4 10.4219 6.26667 11.1993 7.75073 11.1993C9.15234 11.2219 10.5096 10.7087 11.5421 9.76902C14.5089 6.89341 13.6502 4.31467 19.334 4.31467",
    fill: "#30538F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.7511 11.213C19.4278 11.213 17.1705 11.213 15.2071 13.1721C13.5051 14.8756 11.2802 17.7804 9.48108 17.7804C5.78327 17.7804 5.08853 16.0355 3.01054 16.0355C1.43181 16.0192 0 17.0151 0 18.6197C2.02072 16.5879 5.11343 21.5996 9.87327 21.5996C12.7693 21.5996 14.2907 19.3199 15.5993 17.9783C15.8943 17.6814 17.9313 14.3407 21.7511 14.3407C25.0231 14.3407 27.5916 12.8677 28 9.59961C26.364 11.3282 24.3271 11.213 21.7511 11.213",
    fill: "#30538F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFjLogo);
export default __webpack_public_path__ + "static/media/FJLogo.8e224d6fbdb6bead2e47b350cb72a9c7.svg";
export { ForwardRef as ReactComponent };